<template>
    <div class="video">
        <h1 class="text_align_center">Our Ceremony</h1>
        <video-embed src="https://youtu.be/_oXhlnMyIyA"></video-embed>
    </div>
</template>

<script>

export default {
    name: "Video",
}

</script>

<style>

.video {

}

</style>


// WEBPACK FOOTER //
// src/components/Video.vue